"use strict";

exports.__esModule = true;
exports.replaceElementAtPath = replaceElementAtPath;
var shallowCloneElementNotProps = function shallowCloneElementNotProps(input) {
  return {
    type: input.type,
    props: input.props,
    children: input.children.slice()
  };
};

/**
 * Replace the element at a given path returning a new copy of the tree with the replacement in place.
 */
function replaceElementAtPath(root, path, replacement) {
  var clonedRoot = shallowCloneElementNotProps(root);
  if (path.length === 0) {
    return typeof replacement === "function" ? replacement(clonedRoot) : replacement;
  }
  var subject = clonedRoot;
  for (var i = 0; i < path.length; i++) {
    if (subject == null) {
      throw new Error("No such element: " + path.slice(0, i).join("/"));
    }
    var key = path[i];
    if (i === path.length - 1) {
      subject[key] = typeof replacement === "function" ? replacement(subject[key]) : replacement;
      break;
    } else if (typeof key === "number") {
      var clonedChild = shallowCloneElementNotProps(subject[key]);
      subject[key] = clonedChild;
      subject = clonedChild;
    } else {
      subject = subject[key];
    }
  }
  return clonedRoot;
}